import { View, Text } from "react-native";
import React, { useEffect } from "react";
import { createStackNavigator } from "@react-navigation/stack";
import Consultation from "../consultation/Consultation";
import { useDispatch } from "react-redux";
import { changeHeaderColor } from "../../redux/header/headerAction";
import { useIsFocused } from "@react-navigation/native";
import { lighterBlue } from "../../colors";
import Chat from "../consultation/Chat";
import SelectChildren from "../consultation/SelectChildren";
import TutorialCategories from "../tutorial/TutorialCategories";
import TutorialCategory from "../tutorial/TutorialCategory";
import Tutorial from "../tutorial/Tutorial";
import SupportTime from "../main/SupportTime";
import Notifications from "../main/Notifications";
import ChatSettings from "../main/ChatSettings";
import NewTutorial from "../main/NewTutorial";

const Stack = createStackNavigator();

export default function LearnNavigator() {
  return (
    <Stack.Navigator
      screenOptions={{ headerShown: false,animationEnabled:true }}
      initialRouteName="TutorialCategories"
    >
      <Stack.Screen name="TutorialCategories" component={TutorialCategories} />
      <Stack.Screen name="TutorialCategory" component={TutorialCategory} />
      <Stack.Screen name="Tutorial" component={Tutorial} />
      <Stack.Screen name="SupportTime" component={SupportTime} />
      <Stack.Screen name="Notifications" component={Notifications} />
      <Stack.Screen name="ChatSettings" component={ChatSettings} />
      <Stack.Screen name="NewTutorial" component={NewTutorial} />

      <Stack.Screen
        name="Chat"
        options={{
          tabBarStyle: { display: "none" },
        }}
        component={Chat}
      />
    </Stack.Navigator>
  );
}
